import {
  BlackboardFormat,
  BlackboardFrame,
} from "interfaces/models/blackboard";
import { ActionMap } from "interfaces/models/context";
import { InstanceProperty } from "interfaces/models/inspectionInstance";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import { InspectionType } from "interfaces/models/inspectionType";

export type PreviewBlackboardState = {
  itemResults?: InspectionItemResult[];
  blackboardFormat?: BlackboardFormat;
  blackboardFrames?: BlackboardFrame[];
  inspectionType?: InspectionType;
  isLoadingPropertyInstance?: boolean;
  mapInstanceProperty?: Map<string, InstanceProperty>;
};

export enum Types {}

type PreviewBlackboardPayload = {};

// Define the initial state
export const initialPreviewBlackboardState: PreviewBlackboardState = {};

export type PreviewBlackboardActions =
  ActionMap<PreviewBlackboardPayload>[keyof ActionMap<PreviewBlackboardPayload>];

// Define the reducer function
const PreviewBlackboardReducer = (
  state: PreviewBlackboardState,
  action: PreviewBlackboardActions
): PreviewBlackboardState => {
  return state;
};

export { PreviewBlackboardReducer };
